import React from "react";
import { useTranslation } from "react-i18next";

//MUI
import Box from "@mui/material/Box";
import DialogActions from "@mui/material/DialogActions";
import Toolbar from "@mui/material/Toolbar";
import UploadFileIcon from '@mui/icons-material/UploadFile';
import Typography from "@mui/material/Typography";

//Custom Components
import useFormController from "@/components/useFormController";
import DynamicDialog from "@/ui/Dialog/DynamicDialog";
import DialogHeader from "@/ui/Dialog/DialogHeader";
import DialogToolbarHeading from "@/ui/Dialog/DialogToolbarHeading";
import DialogToolbarButtonClose from "@/ui/Dialog/ToolbarButtons/DialogToolbarButtonClose";
import ToolbarFillContent from "@/ui/Toolbar/ToolbarFillContent";
import DialogBody from "@/ui/Dialog/DialogBody";
import DialogActionButton from "@/ui/Dialog/DialogActionButton";
import FormContent from "@/components/FormContent";

//Types
import { FormControllerProps } from "@/@types/components/formController";
import { IDialogProps } from "@/@types/ui/DialogContext";

function KomunalneObvezeDialog(props: IDialogProps) {
  const { t } = useTranslation();

  const { onClose, mode, dc } = props
  const { record, validation, fields, onFieldChange } = useFormController(props as FormControllerProps);

  // FUNCTIONS
  // -------------------------------------------------------------------------------------------

  const handleFieldChange = (value: any, source: string) => {
    if (onFieldChange) {
      if (source ==='export_mode')
        onFieldChange(value.value, source);
      else 
        onFieldChange(value, source);
    }
  };

  function handleClose() {
    onClose({ dataChanged: false, action: mode });
  }

  function handleInsert() {
    onClose({ dataChanged: true, action: mode }, record);
  }

  const records = record['selected_records'];

  const cntObveze = Array.isArray(records) ? records.length : 0;

  // RETURN
  // -------------------------------------------------------------------------------------------
  return (
    <DynamicDialog open={true}>
      <DialogHeader>
        <Toolbar variant="dense" disableGutters={true}>
          <DialogToolbarHeading>{t("titles.komunalne_obveze")}</DialogToolbarHeading>
          <ToolbarFillContent />
          <DialogToolbarButtonClose onClick={handleClose} />
        </Toolbar>
      </DialogHeader>
      <DialogBody>
        <Box m={2}>
          <Typography paragraph={true}>Broj odabranih komunalniih obveza: {cntObveze}</Typography>
          <Typography paragraph={true}>Želite li pokrenuti proces generiranje zapisnika?</Typography>
          <Typography paragraph={true}>Proces se odvija asinkrono kroz Dolphin Scheduler...</Typography>
          <FormContent
            fieldNames={dc.getFormFieldsNames("zapisnici")}
            record={record}
            validation={validation}
            fields={fields}
            onFieldChange={handleFieldChange}
            mode={mode}
            columns={1}
          />
        </Box>
      </DialogBody>
      <DialogActions>
        <DialogActionButton startIcon={<UploadFileIcon />} variant="contained" onClick={handleInsert}  ariaLabel="Generate" ariaControls="Generate">
          {t("buttons.generate_xml")}
        </DialogActionButton>
      </DialogActions>
    </DynamicDialog>
  )
}

export default KomunalneObvezeDialog
